<template>
<BasePage :container="false" class="main-container">

  <Loader v-if="loading"/>
  <Basic404 v-else-if="error">
    <p class="fs-8">Video not found </p>
    <p class="fs-6">Do you have access?</p>
  </Basic404>
  <VideoBase
    v-else
    :video="video"
  />
</BasePage>

</template>

<script>
import VideoBase from './VideoBase'
import Loader from './Loader'
import BasePage from './BasePage'
import Basic404 from './Basic404'

import { fetchVideoBySlug } from '../actionTypes'

import store from '../store'

export default {
  name: 'VideoBySlug',
  components: {
    VideoBase,
    Loader,
    BasePage,
    Basic404,
  },
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      loading: true,
      error: false,
      id: 0,
    }
  },
  async mounted () {
    try {
      this.id = await store.dispatch(fetchVideoBySlug, this.slug)
    } catch (error) {
      this.error = true
    }
    this.loading = false
  },
  computed: {
    video () {
      return store.state.videos[this.id]
    },
  },
}
</script>



// WEBPACK FOOTER //
// VideoBySlug.vue?3cbea8bc